// Import Firebase v7
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/database';
import 'firebase/storage';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
  apiKey: "AIzaSyB_UE25MPPjzp6EJPVeOup6mYJ8eVLSJcQ",
  authDomain: "esimposio-apii.firebaseapp.com",
  databaseURL: "https://esimposio-apii-default-rtdb.firebaseio.com",
  projectId: "esimposio-apii",
  storageBucket: "esimposio-apii.firebasestorage.app",
  messagingSenderId: "789816300428",
  appId: "1:789816300428:web:b1806fb42bde7d53647ca9",
  measurementId: "G-0K1EGCWLXN"
};

// Initialize Firebase if not already initialized
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

// Get Firebase services
const app = firebase.app();
const auth = firebase.auth();
const db = firebase.firestore();
const storage = firebase.storage();

export { firebase, app, auth, db, storage };